import React from 'react';
import { ConnectionLevel } from '../../../../shared/connection-level/connection-level';
import { ConnectionModel } from '../../connection.model';

const ConnectionPlanCell: React.FC<{ connection: ConnectionModel }> = ({ connection }) => {
    return <ConnectionLevel serviceLevel={connection.serviceLevel} />;
};

export default ConnectionPlanCell;